module.exports = __webpack_public_path__ + "static/rebels-sc-52ddaafdbf0978cbf0bcc2f9628d0bfe.png";